/**
 * The `data-testid` marking a crashed subtree, shared with the Playwright suite so a rename
 * is a compile error on both sides.
 *
 * Its own module because Playwright imports it directly, and pulling it from the component
 * would drag a LESS module through a runtime that cannot transpile one. Not part of
 * `E2E_HOOK_CONTRACT` — the external aurora-e2e Robot suite does not select on it.
 */
export const ERROR_FALLBACK_TESTID = 'error-fallback'
